export default "__VITE_ASSET__5992e4a6__"